export default {
  EXPIRED: 1001, // token 过期
  SUCCESS: 200, // 成功
  FAIL: Symbol('FAIL')
}
